import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';

// Utilities
import { config } from 'utilities/woopra';
config({
  domain: 'app.spotter.bot'
});

// MaterialUI
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import createMuiTheme from 'material-ui/styles/createMuiTheme';
import createPalette from 'material-ui/styles/createPalette';
import { blueGrey, red } from 'material-ui/colors';

// Router
import createRouter from 'router5';
import { mobxPlugin } from 'mobx-router5';
import browserPlugin from 'router5/plugins/browser';
import routes from './routes';

// Store
import { store } from './store/Store';

// Router config
const router = createRouter(routes, {}, { store })
  .usePlugin(mobxPlugin(store.routerStore))
  .usePlugin(browserPlugin({ useHash: false }));

// Views
import Root from './views/Root';

import './index.css';

// Theme
const theme = createMuiTheme({
  palette: createPalette({
    type: 'light',
    primary: blueGrey,
    secondary: red,
    error: red
  })
});

router.start(() => {
  ReactDOM.render(
    <Provider store={store} routerStore={store.routerStore}>
      <MuiThemeProvider theme={theme}>
        <Root />
      </MuiThemeProvider>
    </Provider>,
    document.getElementById('root') as HTMLDivElement
  );
});

// Service Worker
// import registerServiceWorker from './registerServiceWorker';
// registerServiceWorker();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx